import React, { useEffect, useState } from "react";

import {
    Box,
    Skeleton,
    TableBody,
    TableCell,
    TableRow,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import {
    TableBodyComponentProps,
    TableBodyLoaderProps
} from "../../types";


const TableBodyLoader = ({
    rowsNum,
    colsNum,
    rowCustomStyles
}: TableBodyLoaderProps) => {
    const theme = useTheme()

    return (
        <>
            {[...Array(rowsNum)].map((_, index) => (
                <TableRow
                    key={index}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        ...rowCustomStyles
                    }}
                >
                    {[...Array(colsNum)].map((_, index) => (
                        <TableCell key={index}>
                            <Skeleton
                                animation="wave"
                                variant="text"
                                aria-hidden="true"
                            />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
};


export default function TableBodyComponent({
    isLoading,
    tableDataCount,
    tableBodyCustomStyles,
    loadingRowsNum,
    loadingColsNum,
    tableBodyLoaderRowCustomStyles,
    tableBody,
}: TableBodyComponentProps): JSX.Element {

    const [announcement, setAnnouncement] = useState("");

    useEffect(() => {
        let timeout: NodeJS.Timeout
        if (isLoading) {
            setAnnouncement("");
            timeout = setTimeout(() => {
                setAnnouncement("Loading table data");
            }, 50);
        } else if (!isLoading && tableDataCount > 0) {
            setAnnouncement("");
            timeout = setTimeout(() => {
                setAnnouncement("Table data loaded");
            }, 50);
        }
        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [isLoading, tableDataCount]);


    return (
        <>
            {/* Screen reader live region */}
            <Box
                role="status"
                aria-live="assertive"
                aria-atomic="true"
                sx={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    border: 0,
                }}
            >
                {announcement}
            </Box>

            <TableBody
                sx={{
                    ...tableBodyCustomStyles
                }}
            >
                {isLoading && (
                    <TableBodyLoader
                        rowsNum={loadingRowsNum}
                        colsNum={loadingColsNum}
                        rowCustomStyles={tableBodyLoaderRowCustomStyles}
                    />
                )}

                {!isLoading && tableDataCount > 0 && (
                    tableBody
                )}
            </TableBody>
        </>
    );
}